import { useState, useRef, useEffect, useCallback } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheckCircle } from '@fortawesome/free-regular-svg-icons';
// import Image from 'next/image';
// import reco from '/public/images/svgs/reco-card.svg';

const LAST_STEP_VALUE = "Let's talk";

const sliderStepsMonthly = [
  [100, 29],
  [200, 59],
  [300, 88],
  [400, 117],
  [500, 146],
  [600, 176],
  [700, 205],
  [800, 234],
  [900, 263],
  [1000, 293],
  [1500, 439],
  [2000, 585],
  [2500, 731],
  [3000, 878],
  [4000, 1170],
  [5000, 1463],
  [6000, 1755],
  [7000, 2048],
  [8000, 2340],
  [9000, 2633],
  [10000, 2691],
  [11000, 2831],
  [12000, 3089],
  [13000, 3346],
  [14000, 3604],
  [15000, 3861],
  [16000, 4118],
  [17000, 4376],
  [18000, 4633],
  [19000, 4779],
  [20000, 4914],
  ['30000', LAST_STEP_VALUE],
];
const sliderStepsYearly = [
  [100, 25],
  [200, 50],
  [300, 75],
  [400, 100],
  [500, 125],
  [600, 150],
  [700, 175],
  [800, 200],
  [900, 225],
  [1000, 250],
  [1500, 375],
  [2000, 500],
  [2500, 625],
  [3000, 750],
  [4000, 1000],
  [5000, 1250],
  [6000, 1500],
  [7000, 1750],
  [8000, 2000],
  [9000, 2250],
  [10000, 2300],
  [11000, 2420],
  [12000, 2640],
  [13000, 2860],
  [14000, 3080],
  [15000, 3300],
  [16000, 3520],
  [17000, 3740],
  [18000, 3960],
  [19000, 4085],
  [20000, 4200],
  ['30000', LAST_STEP_VALUE],
];



const ProCard = ({ isYearly, userId, orgId }) => {
  // const moduleContext = useContext(ModuleContext);
  const defaultStep = 5;
  const inputRef = useRef(500);
  const [users, setUsers] = useState(sliderStepsYearly[defaultStep][0]);
  const [value, setValue] = useState(sliderStepsYearly[defaultStep][1]);
  const [isLastValue, setIsLastValue] = useState(false);

  useEffect(() => {
    // change the default value of the slider on the first render
    inputRef.current.value = defaultStep;
  }, []);


  const changeRangeHandler = useCallback(() => {
    const sliderIndex = inputRef.current.value;
    let users;
    let value;
    if (isYearly) {
      [users, value] = sliderStepsYearly[sliderIndex];
    } else {
      [users, value] = sliderStepsMonthly[sliderIndex];
    }
    if (value === LAST_STEP_VALUE) {
      setIsLastValue(true);
    } else {
      setIsLastValue(false);
    }
    setUsers(users);
    setValue(value);
  }, [isYearly]);

  useEffect(() => {
    if (isYearly) {
      changeRangeHandler();
    } else {
      changeRangeHandler();
    }
  }, [isYearly, changeRangeHandler]);



  return (
    <li className="mt-2 shadow-video rounded-3xl overflow-hidden max-w-full w-96">
      <div className="relative flex flex-col h-28 justify-center text-center py-7 text-authPurple font-bold text-4xl border-b border-[#EAE5FA]">
        <h3>Pro</h3>
        <div className="absolute -top-px -left-0.5">
          {/* <Image src={reco} alt="decorative" /> */}
        </div>
      </div>

      <div className="pt-9 pb-12 px-8">
        <h4 className="font-bold text-2xl opacity-50 text-center mb-7">
          {value !== LAST_STEP_VALUE ? (
            <span>
              <span>${value.toLocaleString('en-US')}</span>/mo
            </span>
          ) : (
            value
          )}
        </h4>
        <p className="text-center leading-loose text-authPurple max-w-[240px] mx-auto mb-2">
          {value !== LAST_STEP_VALUE ? 'Up to:' : 'More than:'} <br />{' '}
          <strong>{users.toLocaleString('en-US')}</strong>{' '}
          <a
            className="underline"
            target="_blank"
            href="https://docs.permit.io/concepts/glossary#mau"
            rel="noreferrer"
          >
            MAU
          </a>{' '}
          ,{' '}
          <strong>
            {' '}
            {value !== LAST_STEP_VALUE
              ? Math.round(users * 0.35).toLocaleString('en-US')
              : '7000'}
          </strong>{' '}
          <a
            className="underline"
            target="_blank"
            href="https://docs.permit.io/concepts/glossary#tenant"
            rel="noreferrer"
          >
            Tenants
          </a>
        </p>
        <div className="mb-3">
          <input
            className="w-full bg-transparent"
            ref={inputRef}
            onChange={changeRangeHandler}
            type="range"
            min="0"
            max={sliderStepsMonthly.length - 1}
            defaultValue={defaultStep}
          />
          <div className="flex justify-between text-[10px] font-bold opacity-50">
            <p className="relative">100</p>
            <p className="relative left-2">30000</p>
          </div>
        </div>
        <div className="flex justify-center mb-3">
          <button
            onClick={() => {
              // ajax post to create-checkout-session with amount from value param
              // then redirect to checkout session url
              if (isLastValue) {
                window.open(
                  'https://docs.google.com/forms/d/e/1FAIpQLScJPNfTasF67H0zS8G8qPoiGDC50EC-U2XFAw48zO-pWv8LjQ/viewform',
                  '_blank'
                );
              } else {
                // add loader to this button on click
                const loader = document.querySelector('#go_pro_loader');
                loader.classList.remove('hidden');

                fetch('https://payment-api-sigma.vercel.app/create-checkout-session', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({ amount: users, isYearly, orgId, userId }),
                })
                  .then((res) => res.json())
                  .then((data) => {
                    console.log(data);
                    window.location.href = data.url;
                  }
                  );
              }
            }
            }
            target="_blank"
            rel="noopener noreferrer"
            className="bg-authPurple text-[#EFF1F4] py-3 w-60 px-8 min-w-[12rem] text-center rounded-full font-bold glow-on-hover"
          >
            <svg id='go_pro_loader' aria-hidden="true" class=" hidden inline w-8 h-8 mr-2 text-gray-200 animate-spin dark:text-gray-600 fill-gray-600 dark:fill-gray-300" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
              <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
            </svg>
            {isLastValue ? "Contact Permit Team" : "Go Pro"}
          </button>
        </div>

        <p className="font-bold text-sm mt-9 mb-3">Community features +</p>
        <ul className="grid grid-cols-1 gap-3">
          <li className="flex justify-start items-start text-sm">
            <FontAwesomeIcon
              className="text-authPurple mr-3 w-[14px] h-[14px] mt-[2px]"
              icon={faCheckCircle}
            />
            <p>
              <a
                className="underline"
                target="_blank"
                href="https://docs.permit.io/integrations/gitops/overview"
                rel="noreferrer"
              >
                Gitops
              </a>{' '}
              (Manage generated policy in Git)
            </p>
          </li>
          <li className="flex justify-start items-start text-sm">
            <FontAwesomeIcon
              className="text-authPurple mr-3 w-[14px] h-[14px] mt-[2px]"
              icon={faCheckCircle}
            />
            <p>
              <a
                className="underline"
                target="_blank"
                href="https://docs.permit.io/features/audit-logs/types"
                rel="noreferrer"
              >
                14 day audit-log retention
              </a>{' '}
              (extendable)
            </p>
          </li>
          <li className="flex justify-start items-start text-sm">
            <FontAwesomeIcon
              className="text-authPurple mr-3 w-[14px] h-[14px] mt-[2px]"
              icon={faCheckCircle}
            />
            <p>Dedicated Slack Support Channel</p>
          </li>
          <li className="flex justify-start items-start text-sm">
            <FontAwesomeIcon
              className="text-authPurple mr-3 w-[14px] h-[14px] mt-[2px]"
              icon={faCheckCircle}
            />
            <p>Email, Chat, and Zoom support</p>
          </li>
        </ul>
      </div>
      {/* <Module
        url={moduleContext.url}
        open={moduleContext.isOpen}
        handleOpen={moduleContext.updateOpenHandler}
      /> */}
    </li>
  );
};

export default ProCard;